
import React from 'react';
import { Star } from 'lucide-react';

interface Testimonial {
  id: number;
  name: string;
  business: string;
  quote: string;
  rating: number;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Caleb Wilson",
    business: "All About Plumbing",
    quote: "Gozango has grown us at least 30% - 40% yearly. The quality of the jobs is bar-none the reason anybody should use Gozango. I would definitely advise anybody to use Gozango.",
    rating: 5
  },
  {
    id: 2,
    name: "Nick Scott",
    business: "The Window Source Franchise",
    quote: "We tested them with [The Window Source (TWS) of] Rhode Island… their revenue went up 30%... Nobody's ever understood my market like these guys… They've literally saved my business… They're at about 10 or 11 locations right now across the TWS network.",
    rating: 5
  },
  {
    id: 3,
    name: "Kwan Wongvian",
    business: "Coastal Contracting",
    quote: "Since we started working with Gozango, our sales numbers have increased exponentially. The leads have gone from 5 [leads a month before Gozango] to about 50 leads a month.",
    rating: 5
  }
];

const TestimonialSection: React.FC = () => {
  return (
    <div className="w-full md:w-1/2 bg-gradient-to-br from-indigo-50 to-purple-100 flex flex-col justify-center items-center p-8 md:p-12">
      <div className="max-w-md mx-auto text-center">
        <h2 className="text-2xl font-bold mb-8 text-gray-800">Join Thousands of Successful Businesses</h2>
        
        <div className="space-y-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white rounded-lg p-6 shadow-md">
              <div className="mb-3 flex justify-center">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <p className="text-gray-700 italic mb-4">"{testimonial.quote}"</p>
              <div className="font-medium text-gray-900">{testimonial.name}</div>
              <div className="text-sm text-gray-500">{testimonial.business}</div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 space-y-4">
          <div className="flex items-center justify-center space-x-4">
            <div className="bg-blue-500 text-white text-sm font-medium rounded-full px-3 py-1">50,000+ Businesses</div>
            <div className="bg-green-500 text-white text-sm font-medium rounded-full px-3 py-1">98% Satisfaction</div>
          </div>
          <p className="text-gray-600 text-sm">
            Join our community of successful businesses today and start growing your customer base.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
